import type { FilterSortSettings } from 'webapp/models-custom/filter-sort/base';
import FilterSortGoal from 'webapp/models-custom/filter-sort/goal';
import type Goal from 'webapp/models-custom/goal';

export const viewSettingsNamePrefix = 'goalsMyViewSettings';
export const settingsNamePrefix = 'goalsMyFilterSettings'; // used to save filter preferences

export default class FilterSortGoalMy extends FilterSortGoal {
	viewSettingsNamePrefix = viewSettingsNamePrefix;
	settingsNamePrefix = settingsNamePrefix;

	constructor(options: FilterSortSettings<Goal>) {
		super(options);

		this.createFilters();
	}

	createFilters(): void {
		const selectedFilters = this.readSavedSelectedFilters();

		this.createTimeframeFilter(selectedFilters);

		this.createFilter<number>({
			id: 7,
			label: 'Status',
			name: 'status',
			selected: selectedFilters[7] as number | undefined,
			isMultiSelect: true,
			getOptions: () => {
				return this.statusOptions;
			},
			filterFn: (item, selected) => {
				return selected.some(
					(selectedValue) => item.primaryDataModel?.status === selectedValue,
				);
			},
		});
	}
}
